'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPropType = exports.render = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _component = require('./component');

var _component2 = _interopRequireDefault(_component);

var _createChainablePropType = require('./createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {*} Component
 * @return {boolean} false if `Component` is a plain function, `true` otherwise
 */
var isReactComponent = function isReactComponent(Component) {
  if (typeof Component !== 'function') return true;
  if (Component.prototype && Component.prototype.isReactComponent) return true;
  return Component.propTypes || Component.defaultProps;
};

var render = exports.render = function render(Renderer, props) {
  return isReactComponent(Renderer) ? _react2.default.createElement(Renderer, props) : Renderer(props);
};

var getPropType = exports.getPropType = function getPropType(_ref) {
  var propTypes = _ref.propTypes,
      defaultProps = _ref.defaultProps;

  return (0, _createChainablePropType2.default)(_component2.default, 'renderProp', {
    propTypes: propTypes,
    defaultProps: defaultProps
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/utils/propTypes/renderProp.js
// module id = 61
// module chunks = 171